import React from 'react'
import {Link} from 'react-scroll';

const Home = () => {
  return (
    <div name='home' className='w-full h-screen bg-[#0a192f]'>
        {/* Container */}
        <div className='max-w-[1000px] mx-auto px-8 flex flex-col justify-center h-full'>
            <p className='text-blue-400'>Hi, I'm</p>
            <hi className='text-4xl sm:text-7xl font-bold text-[#ccd6f6]'>Ahnaf Mahmud</hi>
            <h2 className='text-4xl sm:text-7xl font-bold text-[#8892b0]'>A software developer.</h2>
            <p className='text-[#ffffff] py-4 max-w-[700px]'>I am currently working as a full time iOS developer. During my spare time, I work on my own personal projects which has helped me to improve my skillset. Notable projects today include SubManager, the subscription tracker for Apple devices which has been featured in notable tech publications. My first app, WSA Sideloader was launched in 2022 and has gained more than 300,000 downloads.</p>
            <p className='text-[#ffffff] py-4 max-w-[700px]'>I have also been fortunate to attend Apple's WWDC conference in 2026.</p>
            <div>
                <button className='text-white border-2 px-6 py-3 my-2 flex items-center hover:bg-blue-600 hover:border-blue-600'><Link to="projects" smooth={true} offset={50} duration={500}>
                        View projects
                    </Link>
                </button>
            </div>
        </div>
    </div>
  )
}

export default Home
